export { default } from '../../MediaContainers/MediaContainer/viewer/MediaContainer.previewMapper';
